module.exports = __webpack_public_path__ + "img/img4.c734995e.png";